<template>
	<div>
		<h3>Sections</h3>
		<ul>
			<li v-for="section in sections" :key="section.id">{{section.title}}</li>
		</ul>
	</div>
</template>
<script>
	import App from '@/App'

	export default {
		data: () => {
			return {
				url: App.data().url,
				sections: []
			}
		},
		mounted(){
			App.methods.getData(this.url.sections, (data) => {
				if(data){
					this.sections = data;
				}
			});
		}
	}
</script>